<template>
  <div>
    <b-table hover striped show-empty responsive :items="registrations" :fields="fields" no-border-collapse outlined
             class="table-container" head-variant="light">
      <template #cell(event_type)="data">
        <span class="text-nowrap">
          {{ getEventType(data.item) }}
        </span>
      </template>
      <template #cell(event_name)="data">
        <router-link :to="{ name: eventPathTypeDynamic(data.item.event_type || data.item.registerable_type), params: { id: data.item.registerable_id }}">
          <span class="typo-color-blue cursor-pointer">
            {{ data.item.event_name }}
          </span>
        </router-link>
      </template>
      <template #cell(from_date)="data">
        <span v-if="data.item.from_date && data.item.to_date" class="text-nowrap">
          {{ moment(data.item.from_date, 'YYYY-MM-DD').format('MMM Do, YYYY') }}
          -
          {{ moment(data.item.to_date, 'YYYY-MM-DD').format('MMM Do, YYYY') }}
        </span>
      </template>
      <template #cell(registered_on)="data">
        <span v-if="data.item.registered_on" class="text-nowrap">{{ moment(data.item.registered_on, 'YYYY-MM-DD HH:mm:ss').format('MMM Do, YYYY hh:mm:a') }}</span>
        <span v-else>--</span>
      </template>
      <template #cell(action)="data">
        <i
          v-b-tooltip.hover="'Show Registration Details'"
          class="fas fa-eye cursor-pointer typo-color-blue"
          @click="openModal(data.item.participant_info)"
        />
      </template>
    </b-table>
    <b-modal
      id="registrationDetails"
      ref="registrationDetails"
      title="Registration Details"
      size="lg"
      centered
      hide-footer
    >
      <workshop-participants-tab-show-section :selected-participant="selectedRegistrationParticipant" />
    </b-modal>
  </div>
</template>

<script>
import mixin from "@/utils/mixin.js"
import WorkshopParticipantsTabShowSection from "@/components/ScientificActivity/Workshop/WorkshopDetail/WorkshopParticipantsTabShowSection.vue"

export default {
	name: "PersonRegistrationDetail",
	components: { WorkshopParticipantsTabShowSection },
	mixins: [mixin],
	props: ["registrations"],
	data() {
		return {
			selectedRegistrationParticipant: {},
			fields: [
				{
					key: "event_type",
					label: "Event Type",
				},
				{
					key: "event_name",
					label: "Event",
				},
				{
					key: "from_date",
					label: "Date",
				},
				{
					key: "registered_on",
					label: "Registered On",
				},
				{
					key: "action",
					label: "",
				},
			],
		}
	},
	methods: {
		openModal(participantInfo) {
			this.selectedRegistrationParticipant = participantInfo
			this.$bvModal.show("registrationDetails")
		},
		getEventType(data) {
			if (data.event_type && data.event_type === "SummerResearchWoman") {
				return "SummerResearch"
			}
			return data.event_type || data.registerable_type
		},
	},
}
</script>
